// @flow

import {
  ACTION_ENTERPRISE_ACCOUNT_USER_REPORT_BATCH_LOADING,
  ACTION_ENTERPRISE_ACCOUNT_USER_REPORT_LOADING,
  ACTION_GAME_RESULT_LOADING,
  ACTION_UNLOCK_ALL_LEVELS_LOADING,
  ACTION_SET_CURRENT_ENTERPRISE_ACCOUNT,
  ACTION_SET_CURRENT_APPLICATION,
  ACTION_QUERY_ANALYTICS_SCORE_BY_USER_LOADING,
  ACTION_GET_USER_COMMENTS_LOADING,
  ACTION_QUERY_ANALYTICS_SCORE_LOADING,
  ACTION_GAME_RESULT_BY_USER_LOADING,
  ACTION_USER_INFO_LOADING,
  ACTION_UPDATE_USER_INFO_LOADING,
  ACTION_QUERY_USER_INFO_LOADING,
  ACTION_QUERY_MY_USAGE_REPORT_LOADING,
  ACTION_QUERY_TRAINING_RECORD_BY_USER_LOADING,
  ACTION_GAME_RESULT_AGGREGATION_LOADING,
  ACTION_GAME_RESULT_AGGREGATION_BY_USER_LOADING,
  ACTION_QUERY_USER_SCORE_BENCHMARK_LOADING,
  ACTION_QUERY_USAGE_REPORT_LOADING,
  ACTION_QUERY_USER_GROWTH_REPORT_LOADING,
  ACTION_QUERY_USER_USAGE_REPORT_LOADING,
  ACTION_QUERY_MY_ASSESSMENT_LOADING,
  ACTION_QUERY_ASSESSMENT_BY_USER_LOADING,
  ACTION_ENTERPRISE_USER_LIST_LOADING,
  ACTION_ENTERPRISE_ACCOUNT_LIST_LOADING,
  ACTION_MY_ASSESSMENT_PERFORMANCE_REPORT_LOADING,
  ACTION_ADMIN_COMMON_SETTING_CHANGE,
  ACTION_ENTERPRISE_COMMON_SETTING_CHANGE,
  ACTION_QUERY_LICENSE_TYPES_LOADING,
  ACTION_QUERY_APPLICATIONS_LOADING,
  ACTION_SHOW_LICENSE_LOADING,
  ACTION_UPDATE_LICENSE_LOADING,
  ACTION_CREATE_LICENSE_LOADING,
  ACTION_DELETE_LICENSE_LOADING,
  ACTION_ENTERPRISE_ACCOUNT_SHOW_LOADING,
  ACTION_ENTERPRISE_ACCOUNT_UPDATE_LOADING,
  ACTION_ENTERPRISE_ACCOUNT_ADD_USER_LOADING,
  ACTION_QUERY_EDUCATION_LIST_LOADING,
  ACTION_COMMENT_USER_LOADING,
  ACTION_QUERY_COUNTRY_LIST_LOADING,
  ACTION_AUTHORIZATION_INVITATION_RESULTS_LOADING,
  ACTION_AUTHORIZATION_INVITATIONS_LOADING,
  ACTION_GAME_PERFORMANCE_REPORT_LOADING,
  ACTION_ALL_GAME_PERFORMANCE_REPORT_LOADING,
  ACTION_TRUFOCUS_SESSION_BY_USER_LOADING,
  ACTION_COGOLAND_USERS_WITH_STATUS_LOADING,
  ACTION_COGOLAND_GET_SCHEDULE_BY_USER_LOADING,
  ACTION_COGOLAND_CREATE_SCHEDULE_FOR_USER_LOADING,
  omitByIsNil, ACTION_COGOLAND_RESCHEDULE_SESSION_LOADING
} from './constants'

import type {ModuleSettings, ChartGranularity} from './types'
import type Moment from 'moment'

export const queryAllGamePerformanceReport = (accountId: string, startDate: Moment, endDate: Moment) => {
  return {
    type: ACTION_ALL_GAME_PERFORMANCE_REPORT_LOADING,
    payload: {accountId, startDate, endDate},
  }
}

export const queryAllGamePerformanceReportByUser = (userId: string, startDate: Moment, endDate: Moment, key:string) => {
  return {
    type: ACTION_ALL_GAME_PERFORMANCE_REPORT_LOADING,
    payload: {userId, startDate, endDate, key},
  }
}

export const queryGamePerformanceReport = (gameId: string, accountId: string, key: string) => {
  return {
    type: ACTION_GAME_PERFORMANCE_REPORT_LOADING,
    payload: {gameId, accountId, key},
  }
}

export const unlockAllLevels = (userId: string) => {
  return {
    type: ACTION_UNLOCK_ALL_LEVELS_LOADING,
    payload: userId
  }
}

export const queryInvitations = (accountId: string) => {
  return {
    type: ACTION_AUTHORIZATION_INVITATIONS_LOADING,
    payload: accountId
  }
}

export const sendInvitation = (accountId: string, userIds: Array<string>, licenseId: string) => {
  const payload = {
    accountId,
    userId: userIds.join(',')
  }

  if(licenseId) payload.licenseId = licenseId

  return {
    type: ACTION_AUTHORIZATION_INVITATION_RESULTS_LOADING,
    payload
  }
}

export const queryEducations = () => {
  return {
    type: ACTION_QUERY_EDUCATION_LIST_LOADING
  }
}
export const queryCountries = () => {
  return {
    type: ACTION_QUERY_COUNTRY_LIST_LOADING
  }
}

export const batchEnterpriseUserReport = (accountId: string, userIds: Array<string>, application:string) => {
  return {
    type: ACTION_ENTERPRISE_ACCOUNT_USER_REPORT_BATCH_LOADING,
    payload: {
      accountId,
      userIds,
      application
    }
  }
}

export const setCurrentAccount = (accountId: string) => {
  return {
    type: ACTION_SET_CURRENT_ENTERPRISE_ACCOUNT,
    accountId: accountId
  }
}

export const setCurrentApplication = (application: {}) => {
  return {
    type: ACTION_SET_CURRENT_APPLICATION,
    application: application
  }
}

export const queryEnterpriseUserReport = (userId: string, enterpriseAccountId: string) => {
  return {
    type: ACTION_ENTERPRISE_ACCOUNT_USER_REPORT_LOADING,
    payload: {userId, enterpriseAccountId}
  }
}

export const queryLicenseTypes = () => {
  return {
    type: ACTION_QUERY_LICENSE_TYPES_LOADING,
    payload: {}
  }
}

export const queryUserScoreBenchmark = (params: {}) => {
  return {
    type: ACTION_QUERY_USER_SCORE_BENCHMARK_LOADING,
    payload: params
  }
}

export const queryApplications = () => {
  return {
    type: ACTION_QUERY_APPLICATIONS_LOADING,
    payload: {}
  }
}


export const queryTruFocusSessionsByUser = (userId: string, startDate: Moment, endDate: Moment) => {
  return {
    type: ACTION_TRUFOCUS_SESSION_BY_USER_LOADING,
    payload: {
      allData: true,
      startDate,
      endDate,
      userId
    }
  }
}

export const rescheduleCogolandSession = (sessionId: string, dateTimeUnlock: Moment) => {
  return {
    type: ACTION_COGOLAND_RESCHEDULE_SESSION_LOADING,
    payload: {
      id: sessionId,
      dateTimeUnlock
    }
  }
}

export const getUserComments = (userId: string, enterpriseAccountId: string) => {
  return {
    type: ACTION_GET_USER_COMMENTS_LOADING,
    payload: {
      userId,
      enterpriseAccountId
    }
  }
}

export const commentUser = (comment:{}) => {
  return {
    type: ACTION_COMMENT_USER_LOADING,
    payload: comment
  }
}

export const queryGameResultByUser = (userId: string, startDate: Moment, endDate: Moment) => {
  return {
    type: ACTION_GAME_RESULT_BY_USER_LOADING,
    payload: {
      startDate,
      endDate,
      userId
    }
  }
}

export const queryGameResult = (startDate: Moment, endDate: Moment) => {
  return {
    type: ACTION_GAME_RESULT_LOADING,
    payload: {
      startDate,
      endDate
    }
  }
}

export const queryAnalyticsScore = (startDate: Moment, endDate: Moment) => {
  return {
    type: ACTION_QUERY_ANALYTICS_SCORE_LOADING,
    payload: {
      startDate,
      endDate
    }
  }
}

export const queryAnalyticsScoreByUser = (startDate: Moment, endDate: Moment, userId: string) => {
  return {
    type: ACTION_QUERY_ANALYTICS_SCORE_BY_USER_LOADING,
    payload: {
      startDate,
      endDate,
      userId
    }
  }
}

export const queryUserInfoById = (userId: string) => {
  return {
    type: ACTION_USER_INFO_LOADING,
    payload: {
      userId
    }
  }
}

export const getUserScheduleById = (userId: string) => {
  return {
    type: ACTION_COGOLAND_GET_SCHEDULE_BY_USER_LOADING,
    payload: {
      userId
    }
  }
}

export const createScheduleForUser = (userId: string, startDate: Moment, schedulableDayOfWeek:string) => {
  return {
    type: ACTION_COGOLAND_CREATE_SCHEDULE_FOR_USER_LOADING,
    payload: {
      userId, startDate, schedulableDayOfWeek
    }
  }
}

export const showLicenseById = (id: string) => {
  return {
    type: ACTION_SHOW_LICENSE_LOADING,
    payload: id
  }
}

export const deleteLicenseById = (id: string) => {
  return {
    type: ACTION_DELETE_LICENSE_LOADING,
    payload: id
  }
}

export const updateLicense = (license: {}) => {
  return {
    type: ACTION_UPDATE_LICENSE_LOADING,
    payload: license
  }
}

export const createLicense = (license: {}) => {
  return {
    type: ACTION_CREATE_LICENSE_LOADING,
    payload: license
  }
}

export const updateUserInfoById = (user: {}) => {

  console.log(`updateUserInfoById`)

  return {
    type: ACTION_UPDATE_USER_INFO_LOADING,
    payload: user
  }
}

export const queryUserInfo = () => {
  return {
    type: ACTION_QUERY_USER_INFO_LOADING,
  }
}

export const queryGameResultAggregationByUser = (startDate: Moment, endDate: Moment, granularity: ChartGranularity, userId: string) => {
  return {
    type: ACTION_GAME_RESULT_AGGREGATION_BY_USER_LOADING,
    payload: {
      startDate,
      endDate,
      granularity,
      userId
    }
  }
}

export const queryTrainingRecordsByUser = (startDate: Moment, endDate: Moment, userId: string) => {
  return {
    type: ACTION_QUERY_TRAINING_RECORD_BY_USER_LOADING,
    payload: {
      startDate,
      endDate,
      userId
    }
  }
}

export const queryGameResultAggregation = (startDate: Moment, endDate: Moment, granularity: ChartGranularity) => {
  return {
    type: ACTION_GAME_RESULT_AGGREGATION_LOADING,
    payload: {
      startDate,
      endDate,
      granularity
    }
  }
}

export const queryGrowthReport = (startDate: Moment, endDate: Moment) => {
  return {
    type: ACTION_QUERY_USER_GROWTH_REPORT_LOADING,
    payload: {
      startDate,
      endDate
    }
  }
}

export const queryUsageReport = (startDate: Moment, endDate: Moment, accountId: string) => {
  return {
    type: ACTION_QUERY_USAGE_REPORT_LOADING,
    payload: {
      startDate,
      endDate,
      accountId
    }
  }
}

export const changeAdminCommonSetting = (setting: ModuleSettings) => {
  return {
    type: ACTION_ADMIN_COMMON_SETTING_CHANGE,
    payload: setting
  }
}

export const changeEnterpriseCommonSetting = (setting: ModuleSettings) => {
  return {
    type: ACTION_ENTERPRISE_COMMON_SETTING_CHANGE,
    payload: setting
  }
}

export const queryUsageReportByUser = (startDate: Moment, endDate: Moment, userId: string) => {
  return {
    type: ACTION_QUERY_USAGE_REPORT_LOADING,
    payload: {
      startDate,
      endDate,
      userId
    }
  }
}

export const queryUserUsageReport = (startDate: Moment, endDate: Moment, accountId: string) => {
  return {
    type: ACTION_QUERY_USER_USAGE_REPORT_LOADING,
    payload: {
      startDate,
      endDate,
      accountId
    }
  }
}

export const queryCogoLandUsersWithStatus = (accountId: string) => {
  return {
    type: ACTION_COGOLAND_USERS_WITH_STATUS_LOADING,
    payload: {accountId}
  }
}

export const queryEnterpriseUserList = (accountId: string) => {
  return {
    type: ACTION_ENTERPRISE_USER_LIST_LOADING,
    payload: {accountId}
  }
}

export const queryEnterpriseUserListByApplication = (accountId: string, applicationName: string) => {
  return {
    type: ACTION_ENTERPRISE_USER_LIST_LOADING,
    payload: {accountId, applicationName}
  }
}


export const queryEnterpriseAccounts = function (id) {
  return {
    type: ACTION_ENTERPRISE_ACCOUNT_LIST_LOADING,
    payload: omitByIsNil({id})
  }
}

export const queryMyUsageReport = (startDate: Moment, endDate: Moment) => {
  return {
    type: ACTION_QUERY_MY_USAGE_REPORT_LOADING,
    payload: {startDate, endDate}
  }
}

export const queryMyAssessment = (params: {}) => {
  return {
    type: ACTION_QUERY_MY_ASSESSMENT_LOADING,
    payload: params
  }
}

export const queryAssessmentByUser = (params: {}) => {
  return {
    type: ACTION_QUERY_ASSESSMENT_BY_USER_LOADING,
    payload: params
  }
}

export const queryMyLatestAssessment = () => {
  return {
    type: ACTION_QUERY_MY_ASSESSMENT_LOADING,
    payload: {
      max: 1,
      offset: 0,
      sort: 'assessmentDate',
      order: 'desc'
    }
  }
}

export const queryLatestAssessmentByUser = (userId: string) => {
  return {
    type: ACTION_QUERY_ASSESSMENT_BY_USER_LOADING,
    payload: {
      userId,
      max: 1,
      offset: 0,
      sort: 'assessmentDate',
      order: 'desc'
    }
  }
}

export const queryMyAssessmentPerformanceReport = function (startDate: Moment, endDate: Moment) {
  return {
    type: ACTION_MY_ASSESSMENT_PERFORMANCE_REPORT_LOADING,
    payload: {
      startDate,
      endDate,
    }
  }
}

export const queryEnterpriseAccount = (id: string) => {
  return {
    type: ACTION_ENTERPRISE_ACCOUNT_SHOW_LOADING,
    payload: {id}
  }
}

export const updateEnterpriseAccount = (data: {}) => {
  return {
    type: ACTION_ENTERPRISE_ACCOUNT_UPDATE_LOADING,
    payload: data
  }
}

export const enterpriseUserAdd = (data: {}) => {
  return {
    type: ACTION_ENTERPRISE_ACCOUNT_ADD_USER_LOADING,
    payload: data
  }
}



// WEBPACK FOOTER //
// ./src/dispatch.js